import classNames from 'classnames';
import { FC } from 'react';
import { ArrowDown, ArrowUp, Text } from '@doda/io-react/common';
import styles from './index.module.scss';

interface Props {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isOpen: boolean;
}

/**
 * 関連情報のトグルボタン
 * @param onClick ボタン押下時ハンドラ
 * @param isOpen アコーディオンの開閉フラグ
 */
export const ToggleButton: FC<Props> = ({ onClick, isOpen }) => {
  const label = isOpen ? '閉じる' : '続きを見る';
  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(
        styles['jobSearchDetail-relationInformationListToggleButton'],
        {
          [styles['jobSearchDetail-relationInformationListToggleButton--blur']]:
            !isOpen,
        }
      )}
    >
      <Text as="span" color="blue" weight="bold">
        {label}
      </Text>
      <span
        className={
          styles[
            'jobSearchDetail-relationInformationListToggleButton__arrowIcon'
          ]
        }
      >
        {isOpen ? (
          <ArrowUp size="M" color="blue" />
        ) : (
          <ArrowDown size="M" color="blue" />
        )}
      </span>
    </button>
  );
};
